// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"06255e68","292":"7fbcbdbb","306":"53cce0cc","607":"37326fea","744":"bb0542fa"}[chunkId] + ".chunk.css";
};